import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { AttachmentCardStoreContext } from './contexts/StoreContext'
import { AttachmentCardStoreProviderProps } from './interface'
import { createAttachmentCardStore } from './store/createStore'
import { AttachmentCardStoreUpdater } from './StoreUpdater'

export const AttachmentCardStoreProvider = ({
  children,
  /* -------------------------------------------------------------------------- */
  /*                      AttachmentCardStoreUpdater Props                      */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: PropsWithChildren<AttachmentCardStoreProviderProps>) => {
  const cardRef = useRef<HTMLDivElement>(null)
  const store = useCreation(() => createAttachmentCardStore({ cardRef }), [])

  return (
    <AttachmentCardStoreContext value={store}>
      <AttachmentCardStoreUpdater {...restProps} />
      {children}
    </AttachmentCardStoreContext>
  )
}
